import * as types from './types'

export const toggleSidebar = () => ({
  type: types.TOGGLE_SIDEBAR
})

export const toggleCategory = (category) => ({
  type: types.TOGGLE_CATEGORY,
  category
})

export const loadTrack = (track) => ({
  type: types.LOAD_TRACK,
  track
})

export const toggleCurrentTrack = (force=undefined) => ({
  type: types.TOGGLE_CURRENT_TRACK,
  force
})

export const tickCurrentTrack = (tick) => ({
  type: types.TICK_CURRENT_TRACK,
  tick
})

export const seekCurrentTrack = (time) => ({
  type: types.SEEK_CURRENT_TRACK,
  time
})

export const unseekCurrentTrack = () => ({
  type: types.UNSEEK_CURRENT_TRACK
})

export function playNextTrack () {
  return (dispatch, getState) => {
    dispatch(toggleCurrentTrack(false))

    const state = getState()

    const currentTrackId = state.currentTrack.meta.id
    const nextTrackIndex = state.tracks.tracks.findIndex(track => track.id === currentTrackId) +1

    dispatch(loadTrack(state.tracks.tracks[nextTrackIndex]))
    dispatch(toggleCurrentTrack())
  }
}

export function playPreviousTrack () {
  return (dispatch, getState) => {
    dispatch(toggleCurrentTrack(false))

    const state = getState()

    const currentTrackId = state.currentTrack.meta.id
    const previousTrackIndex = state.tracks.findIndex(track => track.id === currentTrackId) -1

    // Handle case when clicking previous on first track
    if (previousTrackIndex < 0) {
      dispatch(seekCurrentTrack(0))
      dispatch(toggleCurrentTrack(true))
      return
    }

    dispatch(loadTrack(state.tracks[previousTrackIndex]))
    dispatch(toggleCurrentTrack())
  }
}

export const receiveTracks = (book, response) => ({
  type: types.RECEIVE_TRACKS,
  book,
  response
})

export const setVolume = (volume) => ({
  type: types.SET_VOLUME,
  volume
})

// Set the state of the track in state.tracks to be cached. This does not change whether or not it is cached, only for visuals
export const setTrackCached = (track) => ({
  type: types.SET_TRACK_CACHED,
  track
})

export const chapterSearch = (chapter) => ({
  type: types.CHAPTER_SEARCH,
  chapter
})

// audioPlayer
export const setHTML5 = (enabled) => ({
  type: types.SET_HTML5,
  enabled
})

export const setSource = (source) => ({
  type: types.SET_SOURCE,
  source
})



// WEBPACK FOOTER //
// ./src/actions/index.js